import React from "react";

const DETAILS = [
    { label: "Office Hours", value: "Sunday – Thursday, 09:00 – 18:00" },
    { label: "Address",      value: "8a Saknai St., Hod Hasharon, 4535308, Israel" },
    { label: "General",      value: "info@sys-it.co.il" },
    { label: "Support",      value: "help@sys-it.co.il" },
    { label: "Telephone",    value: "+972 3 644 0671" },
    { label: "Fax",          value: "+972 77 400 4913" },
];

const Contact: React.FC = () => (
    <section className="contact" id="contact">
        <div className="section-number">06</div>
        <div className="container">
            <div className="contact-grid">
                <div className="contact-left">
                    <span className="section-eyebrow">Get in Touch</span>
                    <h2 className="section-title">
                        Let's Elevate<br />Your IT
                    </h2>
                    <div className="contact-details">
                        {DETAILS.map(d => (
                            <div className="contact-detail" key={d.label}>
                                <div className="detail-label">{d.label}</div>
                                <div className="detail-value">{d.value}</div>
                            </div>
                        ))}
                    </div>
                </div>

                <div className="contact-right">
                    <div className="contact-cta-card">
                        <h3>Ready to Transform<br />Your Infrastructure?</h3>
                        <p>
                            Schedule a free consultation to assess your current systems
                            and discover how Syslogics can accelerate your business growth.
                        </p>
                        <button className="btn-gold">Book Free Consultation</button>
                        <div className="contact-options">
                            <span>English support</span>
                            <div className="dot-sep" />
                            <span>Hebrew support</span>
                            <div className="dot-sep" />
                            <span>On-site visits</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
);

export default Contact;
